<!-- Layout novo (o da Minha Carteira e do Dashboard), 01/10/2026. -->
<header class="page-head" data-testid="add-credits-page">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-money"></i></span>
    <div>
      <h1 class="page-head__title">Adicionar créditos</h1>
      <p class="page-head__subtitle">
        Pacote de SMS ou de ligação, ou saldo em R$ na carteira — que paga WhatsApp e IA
      </p>
    </div>
  </div>
  <div class="page-head__actions">
    <button type="button" class="sf-btn sf-btn--secondary sf-btn--pill" (click)="back()" data-testid="btn-back">
      <i class="fa fa-arrow-left"></i> Voltar
    </button>
  </div>
</header>

<form (submit)="save()" [formGroup]="rechargeForm" #myForm="ngForm">
  <section class="sf-card">
    <div class="choice-row">
      <div class="field">
        <label>Tipo de saldo</label>
        <!-- WhatsApp e Tokens IA saíram em 01/10/2026: os dois são pagos pelo Saldo. -->
        <div class="sf-btn-group" role="group" aria-label="Tipo de saldo" data-testid="target-group">
          <button type="button" class="sf-btn sf-btn--sm" [class.is-active]="isSms" [attr.aria-pressed]="isSms"
            (click)="targetChanged('sms')" data-testid="btn-target-sms">
            <i class="fa fa-commenting"></i><span>SMS</span>
          </button>
          <button type="button" class="sf-btn sf-btn--sm" [class.is-active]="isCall" [attr.aria-pressed]="isCall"
            (click)="targetChanged('call')" data-testid="btn-target-call">
            <i class="fa fa-phone"></i><span>Ligação</span>
          </button>
          <button type="button" class="sf-btn sf-btn--sm" [class.is-active]="isBalance" [attr.aria-pressed]="isBalance"
            (click)="targetChanged('balance')" data-testid="btn-target-balance">
            <i class="fa fa-money"></i><span>Saldo (R$)</span>
          </button>
        </div>
      </div>

      <div class="field">
        <label>Tipo de crédito</label>
        <div class="sf-btn-group" role="group" aria-label="Tipo de crédito" data-testid="type-group">
          <button type="button" class="sf-btn sf-btn--sm" [class.is-active]="isRecharge"
            [attr.aria-pressed]="isRecharge" (click)="typeChanged('recharge')" data-testid="btn-type-recharge">
            <span>Recarga</span>
          </button>
          <button type="button" class="sf-btn sf-btn--sm" [class.is-active]="!isRecharge"
            [attr.aria-pressed]="!isRecharge" (click)="typeChanged('transfer')" data-testid="btn-type-transfer">
            <span>Transferência</span>
          </button>
        </div>
      </div>
    </div>

    <div class="balance-notice alert" *ngIf="isBalance && isRecharge" data-testid="balance-notice">
      <i class="fa fa-info-circle"></i>
      <span>
        O valor pago entra na <strong>carteira do cliente em R$</strong> e paga WhatsApp e IA — é o mesmo
        "Adicionar saldo" que o cliente faz no painel, com o bônus da faixa.
      </span>
    </div>

    <!-- A carteira é por fila: o crédito no destino só sai depois que o débito na origem é confirmado. -->
    <div class="balance-notice alert" *ngIf="isBalanceTransfer" data-testid="balance-transfer-notice">
      <i class="fa fa-info-circle"></i>
      <span>
        O valor <strong>sai primeiro da carteira de origem</strong> e só entra na de destino depois que a
        carteira confirmar o débito — leva cerca de um minuto. Sem saldo na origem, nada é transferido.
      </span>
    </div>

    <div class="field-grid">
      <div class="field" *ngIf="!isRecharge">
        <label for="origin_user">Usuário de origem</label>
        <input #inputOrigin type="text" name="origin_user" id="origin_user" class="form-control"
          data-testid="input-origin-user" placeholder="Buscar por nome ou e-mail…"
          [formControl]="userControlOrigin" [matAutocomplete]="autoOrigin" (input)="filterOrigin()" />
        <mat-autocomplete requireSelection #autoOrigin="matAutocomplete" [displayWith]="displayUser">
          <mat-option [value]="user" *ngFor="let user of filteredUserOrigin$ | async">
            {{ displayUser(user) }}
          </mat-option>
        </mat-autocomplete>
      </div>

      <div class="field" [class.field--wide]="isRecharge">
        <label for="destination_user">{{ isRecharge ? 'Cliente' : 'Usuário de destino' }}</label>
        <input #inputDestination type="text" name="destination_user" id="destination_user" class="form-control"
          data-testid="input-destination-user" placeholder="Buscar por nome ou e-mail…"
          [formControl]="userControlDestination" [matAutocomplete]="autoDestination" (input)="filterDestination()" />
        <mat-autocomplete requireSelection #autoDestination="matAutocomplete" [displayWith]="displayUser">
          <mat-option [value]="user" *ngFor="let user of filteredUserDestination$ | async">
            {{ displayUser(user) }}
          </mat-option>
        </mat-autocomplete>
      </div>

      <ng-container *ngIf="isRecharge">
        <div class="field">
          <label for="payment_type">Forma de pagamento</label>
          <input type="text" name="payment_type" id="payment_type" class="form-control" formControlName="payment_type"
            maxlength="20" placeholder="Ex.: pix" data-testid="input-payment-type" />
        </div>
        <div class="field">
          <label for="payment_status">Status</label>
          <input type="text" name="payment_status" id="payment_status" class="form-control"
            formControlName="payment_status" maxlength="20" placeholder="Ex.: pago" data-testid="input-payment-status" />
        </div>
      </ng-container>

      <!-- Transferência de Saldo: valor em R$, limitado ao disponível da origem -->
      <div class="field" *ngIf="isBalanceTransfer">
        <label for="transfer_amount">Valor a transferir</label>
        <div class="input-group">
          <span class="input-group-text">BRL</span>
          <input type="number" id="transfer_amount" class="form-control" [formControl]="transferAmount" min="0.01"
            step="0.01" placeholder="0,00" data-testid="input-transfer-amount" />
        </div>
        <small class="field-hint" *ngIf="isLoadingOriginBalance" data-testid="origin-balance-loading">
          Consultando o saldo da origem...
        </small>
        <small class="field-hint" *ngIf="originBalance && !isLoadingOriginBalance" data-testid="origin-balance">
          Disponível na origem: {{ originBalance.available_micros | moneyMicros : originBalance.currency }}
        </small>
        <small class="field-hint" *ngIf="originBalanceUnavailable" data-testid="origin-balance-unavailable">
          Não deu para consultar o saldo da origem; a carteira confere no débito.
        </small>
        <small class="field-error" *ngIf="transferAmountTooManyDecimals" data-testid="transfer-too-many-decimals">
          Use no máximo 2 casas decimais.
        </small>
        <small class="field-error" *ngIf="transferAmountUnreadable" data-testid="transfer-unreadable">
          Valor inválido. Use o formato 10.50.
        </small>
        <small class="field-error" *ngIf="originCurrencyMismatch" data-testid="transfer-currency-mismatch">
          A carteira de origem está em {{ originBalance.currency }}; a transferência é em BRL e só vale entre
          carteiras em BRL.
        </small>
        <small class="field-error" *ngIf="transferExceedsBalance" data-testid="transfer-exceeds">
          O valor passa do saldo disponível na origem.
        </small>
        <small class="field-error" *ngIf="sameTransferUser">Origem e destino precisam ser contas diferentes.</small>
        <small class="field-error" *ngIf="transferError" data-testid="transfer-error">{{ transferError }}</small>
      </div>

      <!-- Saldo: só o valor pago, em R$ -->
      <div class="field" *ngIf="isBalance && isRecharge">
        <label for="total">Valor pago</label>
        <div class="input-group">
          <span class="input-group-text">BRL</span>
          <input type="number" name="total" id="total" class="form-control" formControlName="total" min="0"
            step="0.01" placeholder="0,00" data-testid="input-total" />
        </div>
        <small class="field-hint">Entra na carteira quando a recarga for confirmada.</small>
      </div>

      <!-- SMS e Ligação: pacote, como antes -->
      <ng-container *ngIf="!isBalance">
        <div class="field" *ngIf="!isRecharge && !originBilledByWallet">
          <label for="credits_available">Créditos disponíveis</label>
          <input id="credits_available" type="number" class="form-control" readonly
            data-testid="input-credits-available" [value]="availableCredits" />
          <small class="field-error" *ngIf="userControlOrigin.value && availableCredits === 0">
            Usuário não possui créditos de {{ getServiceName() }}.
          </small>
        </div>

        <!-- Origem que paga o produto pela carteira: o pacote (zerado na migração) não conta;
             o backend converte os créditos em R$ pelo preço da origem e confere o saldo. -->
        <div class="field" *ngIf="!isRecharge && originBilledByWallet" data-testid="origin-wallet-billed">
          <label>Carteira da origem</label>
          <small class="field-hint">
            A origem paga {{ getServiceName() }} pela carteira: os créditos viram R$ pelo preço dela, e a carteira
            confere o saldo no débito.
          </small>
          <small class="field-hint" *ngIf="originBalance && !isLoadingOriginBalance" data-testid="origin-wallet-balance">
            Disponível na carteira da origem: {{ originBalance.available_micros | moneyMicros : originBalance.currency }}
          </small>
        </div>

        <div class="field">
          <label for="credits">Créditos</label>
          <input type="number" name="credits" id="credits" class="form-control" formControlName="credits"
            data-testid="input-amount-credits" />
          <small class="field-error" *ngIf="!isRecharge && invalidCredits">
            Você pode transferir no máximo {{ availableCredits }} crédito(s).
          </small>
          <small class="field-error" *ngIf="!isRecharge && sameTransferUser" data-testid="credits-same-user">
            Origem e destino precisam ser contas diferentes.
          </small>
        </div>

        <ng-container *ngIf="isRecharge">
          <div class="field">
            <label for="total">Valor pago</label>
            <div class="input-group">
              <span class="input-group-text">BRL</span>
              <input type="number" name="total" id="total" class="form-control" formControlName="total"
                data-testid="input-total" />
            </div>
          </div>
          <div class="field">
            <label for="price">Valor por {{ getServiceName() }}</label>
            <div class="input-group">
              <span class="input-group-text">BRL</span>
              <input type="number" name="price" id="price" class="form-control" formControlName="price" readonly
                data-testid="input-price" />
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <!-- Bônus de recarga: só do Saldo (ver `showsBonus`) -->
    <div class="bonus-box" *ngIf="showsBonus" data-testid="bonus-box">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="bonus_enabled"
          formControlName="bonus_enabled" data-testid="input-bonus-enabled" />
        <label class="form-check-label" for="bonus_enabled">Dar bônus de recarga</label>
      </div>

      <!-- Config da conta (CU-17tm466tzkz): o switch veio desmarcado por ela. -->
      <small class="bonus-line bonus-muted" *ngIf="accountReceivesBonus === false && !bonusEnabled"
        data-testid="bonus-account-opt-out">
        Esta conta está configurada para <strong>não receber bônus de recarga</strong>.
        Marque acima só se quiser forçar o bônus nesta recarga.
      </small>
      <small class="bonus-line" *ngIf="isBonusForced" data-testid="bonus-forced">
        <i class="fa fa-exclamation-triangle"></i>
        Bônus <strong>forçado</strong>: esta conta normalmente não recebe bônus de recarga.
      </small>

      <small class="bonus-line" *ngIf="!bonusEnabled && accountReceivesBonus !== false" data-testid="bonus-off">
        Esta recarga entra <strong>sem bônus</strong>, mesmo que o valor alcance uma faixa.
      </small>

      <small class="bonus-line" *ngIf="bonusEnabled && isQuotingBonus" data-testid="bonus-loading">
        Consultando a faixa de bônus...
      </small>

      <!-- A cotação é informativa: falhar aqui não pode impedir a recarga,
           e quem decide o bônus é o backend no lançamento. -->
      <small class="bonus-line bonus-muted" *ngIf="bonusEnabled && bonusQuoteError" data-testid="bonus-error">
        Não foi possível consultar a faixa de bônus agora. A recarga continua disponível.
      </small>

      <ng-container *ngIf="bonusEnabled && bonusQuote && !isQuotingBonus">
        <small class="bonus-line bonus-applied" *ngIf="bonusQuote.bonus_micros > 0" data-testid="bonus-amount">
          Bônus da faixa: <strong>{{ bonusQuote.bonus_micros | moneyMicros }}</strong>
          — a carteira ficaria com
          {{ bonusQuote.paid_micros + bonusQuote.bonus_micros | moneyMicros }}.
        </small>

        <!-- Zero com motivo é diferente de zero sem motivo: o motivo diz
             se foi a faixa que não bateu ou uma exclusão do cliente. -->
        <small class="bonus-line bonus-muted" *ngIf="bonusQuote.bonus_micros === 0"
          [class.bonus-unknown]="isBonusUnknown" data-testid="bonus-reason">
          {{ bonusReason(bonusQuote.reason) }}
        </small>

        <!-- Conta com contrato e config ligada: marcar o switch não fura o contrato (é a
             config da conta, não forçar). Enquanto a regra for esta, a tela diz o caminho. -->
        <small class="bonus-line bonus-muted"
          *ngIf="accountReceivesBonus === true && bonusQuote.reason === 'account_price_excluded'"
          data-testid="bonus-contract-hint">
          Para dar bônus a esta conta com contrato, desligue "Recebe bônus de recarga" na tela
          do usuário e marque o switch acima.
        </small>
      </ng-container>
    </div>

    <div class="field description-field">
      <div class="description-label">
        <label for="description">Observações</label>
        <small class="field-hint">{{ rechargeForm.get('description').value?.length || 0 }}/100</small>
      </div>
      <textarea id="description" class="form-control" formControlName="description" maxlength="100" rows="3"></textarea>
      <small class="field-error" *ngIf="rechargeForm.get('description').errors?.maxlength">
        O texto deve ter apenas 100 caracteres
      </small>
    </div>

    <!-- Status 0 ou 5xx: a transferência pode ter sido registrada. Repetir o MESMO pedido de Saldo é
         seguro (mesma idempotency_key); outro pedido sai com chave nova e passa pela confirmação — e,
         nos créditos de SMS/ligação, até repetir passa (no pacote a chave não vale). O aviso fica até
         um sucesso ou até sair da tela. -->
    <ng-container *ngIf="!isRecharge && uncertainTransfer">
      <div class="balance-notice alert alert-warning" role="alert" *ngIf="isSafeRepeatOfUncertainTransfer"
        data-testid="transfer-outcome-unknown">
        <i class="fa fa-exclamation-triangle"></i>
        <span>{{ transferOutcomeUnknownMessage }}</span>
      </div>

      <div class="balance-notice alert alert-warning" role="alert" *ngIf="needsNewTransferConfirmation"
        data-testid="transfer-outcome-unknown-other">
        <i class="fa fa-exclamation-triangle"></i>
        <div>
          <span>
            A tentativa de <strong>{{ uncertainTransfer.label }}</strong> para
            <strong>{{ uncertainTransfer.destinationLabel }}</strong> pode ter sido registrada;
            {{ isRepeatingUncertainTransfer
              ? 'confira os créditos e o extrato da origem antes de enviar de novo.'
              : 'confira o extrato antes de transferir outro valor.' }}
          </span>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="confirm_new_transfer"
              [formControl]="confirmNewTransfer" data-testid="input-confirm-new-transfer" />
            <label class="form-check-label" for="confirm_new_transfer">
              {{ isRepeatingUncertainTransfer
                ? 'Conferi e quero enviar de novo'
                : 'Conferi o extrato e quero fazer esta outra transferência' }}
            </label>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="form-actions">
      <button type="submit" class="sf-btn sf-btn--primary" [appLoadingButton]="isSaving" [disabled]="isInvalid"
        data-testid="btn-confirm-credits">
        <i class="fa" [class.fa-plus-circle]="isRecharge" [class.fa-exchange]="!isRecharge"></i>
        {{ isRecharge ? 'Adicionar' : 'Transferir' }}
      </button>
    </div>
  </section>
</form>
